import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createQueryDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/Query/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.createdAt = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackQuery = db.doc(`/Query/${uniqueId}`);
    await getBackQuery.get().then(result => {
        console.info('result',result?.exists)
        if(result?.exists) {
            return true;
        } else {
            return false
        }
    });
}

export const getQueryDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Query').where("userId","==", userId).get()
    return snapshot.docs.map(doc => doc.data());
}

export const getQueryDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Query').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => doc.data());
}

export const getAllQueryDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Query').get()
    return snapshot.docs.map(doc => doc.data());
}

export const updateQueryDocument = async (query) => {
    const docRef = db.doc(`/Query/${query.uniqueId}`);
    return docRef.update(query);
}